/**
 * VIVA mark for HUB chrome — swaps to the white logo on dark theme
 * so navy artwork stays visible on navy surfaces.
 */

import React from 'react'
import { useHubTheme } from '../../contexts/HubThemeContext'

const LOGO_LIGHT = '/img/logo/Logo-nobg-300x300.png'
const LOGO_DARK = '/img/logo/White-logo-no-background-300x300.png'

export default function HubBrandLogo({ className = 'h-8 w-8', alt = 'VIVA Psychotherapy' }) {
  const { isDark } = useHubTheme()

  return (
    <img
      src={isDark ? LOGO_DARK : LOGO_LIGHT}
      alt={alt}
      className={className}
    />
  )
}
